//import devConfig from 'theme/theme.json';
let themeConfig: Record<string, any> = {};

try {
  const rawTheme = process.env.REACT_APP_THEME;
  if (rawTheme) {
    themeConfig = JSON.parse(rawTheme);
  }
  // if testing local theme/theme.json, uncomment the line below and comment out the lines above
  /* if (devConfig) {
    themeConfig = devConfig;
  } */
} catch (e) {
  console.warn('[ThemeConfig] Error parsing REACT_APP_THEME', e);
  themeConfig = {};
}

export const appThemeConfig = themeConfig;
